export enum MenuVariant {
  STANDARD = 'standard',
  MINI = 'mini',
}

export enum Menu {
  Main = 'main',
  Secondary = 'secondary',
}
